"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Used to set the first tab width
const constants_1 = require("../../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        marginRight: constants_1.TAB_MARGIN_RIGHT,
        padding: '10px 0',
        fontSize: 12,
        color: theme.grey1,
        '&[data-has-folder=true]': {
            padding: '15px 20px',
            borderRadius: '5px 5px 0px 0px',
            fontSize: 18,
            fontWeight: 700,
            color: theme.grey4,
            marginRight: 0
        },
        '& span': {
            marginRight: 10,
            '&:empty': {
                display: 'none'
            }
        },
        '&:hover': {
            cursor: 'pointer'
        },
        '&:first-letter': {
            textTransform: 'uppercase'
        },
        '&[data-is-active=true]&[data-has-folder=true]': {
            color: theme.grey1,
            backgroundColor: 'white'
        }
    }
});
//# sourceMappingURL=tab.style.js.map